const Validation = {
    
    textinputValidator(e) {
      let isValidate = false;
      if (!/^[A-Za-z? ,_-]+$/.test(e.key)) {
        e.preventDefault();
      }
      return isValidate;
    },
    numberinputValidator(e) {
      let isValidate = false;
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
      return isValidate;
    },
    mobileNumberValidator(value){
      const regex = new RegExp('/^[0-9\b]+$/;');
      let isValidate = false;
      if (value === " " || regex.test(value) === true ||!value.match("[0-9]{10}")) {
        isValidate = true;
      }
      return isValidate;
    },
    pincodeValidator(e, value) {
      let isValidate = false;
      if(value==""){
        return false;
      }
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
      else if (value.length !== 5) {
        isValidate = true;
      }
      return isValidate;
    },
    
  
  }
  
  export default Validation
  